import { gql } from '@apollo/client';

const ProductionOrderListInfo = gql`
  fragment ProductionOrderListInfo on ProductionOrder {
    id
    state
    hexCode
    importOrderType
    sentToExternalManufacturer
    sendToClinic
    arches
    upperArchQuantity
    lowerArchQuantity
    patient {
      id
      firstName
      lastName
    }
    partnerLocation {
      id
      name
    }
    productionOrderItemsAttributes {
      id
      name
      quantity
      trackingNumber
      trackingUrl
      labelUrl
      manufacturerExternalId
      shippingCarrier {
        id
        name
      }
      product {
        id
        name
      }
      patient {
        id
        firstName
        lastName
      }
    }
    createdAt
    updatedAt
  }
`;

export default ProductionOrderListInfo;
